var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"numberInput",staticStyle:{"text-align":"right"},attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"blur":function (e) { return _vm.handleNumberInput(e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }